import SegmentedControl from 'components/shared/SegmentedControl/SegmentedControl';
import Typography from 'components/shared/Typography/Typography';

import { PRE_PHASE_TAB_OPTIONS } from './lib/helpers';

const PerPhaseConfiguration = ({
  phases = [],
  onChange,
  activePhaseField,
  setActivePhaseField
}) => {
  const activeOption = PRE_PHASE_TAB_OPTIONS.find((option) => option.field === activePhaseField);
  const Component = activeOption?.component;

  const activePhase = phases.find((p) => p.field === activePhaseField);

  const handlePhasePatch = (patch) => {
    onChange(phases.map((p) => (p.field === activePhaseField ? { ...p, ...patch } : p)));
  };

  if (!Component) return null;

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <Typography variant="h6">
          Per-phase configuration (Pre-Authorized Healthcare form)
        </Typography>
        <Typography variant="p" size="small" color="neutral-700" className="block">
          The Pre-Authorized Healthcare form has <span className="font-semibold">three phases</span>
          , one per patient scenario. Configure card-on-file behavior, eligibility-based
          calculations, charge limits (caps), and authorization terms for each. The cap you set on
          every phase can optionally appear on your Patient Option Letter.
        </Typography>
      </div>
      <SegmentedControl
        items={PRE_PHASE_TAB_OPTIONS}
        active={activePhaseField}
        onClick={(option) => setActivePhaseField(option.field)}
      />
      <Component phase={activePhase} onChange={handlePhasePatch} />
    </div>
  );
};

export default PerPhaseConfiguration;
